import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "topbar-call-to-action"
}
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.callToAction)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", {
              class: "text-white",
              innerHTML: _ctx.action.message
            }, null, 8, _hoisted_4)
          ]),
          _createVNode(_component_router_link, {
            class: "btn btn-sm btn-primary",
            id: "kt_toolbar_primary_button",
            to: _ctx.callToAction.route
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.action.button), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ]))
    : _createCommentVNode("", true)
}